<div class="shade"></div>

<ng-content></ng-content>
